import createReactComponent from '../createReactComponent';
export default createReactComponent('info', 'Info', [["path",{"d":"M12 19.5v-10h-.5m0 10h1m-.5-14V5","key":"svg-0"}]]);